module.exports = __webpack_public_path__ + "655fa2a365309983499aa16a3850beb8.png";